module.exports = __webpack_public_path__ + "media/images/recommended-646a047d.svg";